
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const BookingPage = lazy(() => import('../pages/booking/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <BookingPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;